import { ReactExtensions, UseRemirrorReturn } from '@remirror/react';
import { createContextState } from 'create-context-state';
import jsx from 'refractor/lang/jsx.js';
import md from 'refractor/lang/markdown.js';
import typescript from 'refractor/lang/typescript.js';
import { ExtensionPriority } from 'remirror';
import {
  BoldExtension,
  BulletListExtension,
  CodeBlockExtension,
  CodeExtension,
  DocExtension,
  DropCursorExtension,
  HardBreakExtension,
  HeadingExtension,
  ImageExtension,
  ItalicExtension,
  LinkExtension,
  ListItemExtension,
  MarkdownExtension,
  NodeFormattingExtension,
  OrderedListExtension,
  StrikeExtension,
  TableExtension,
  TrailingNodeExtension
} from 'remirror/extensions';

import '@remirror/styles/all.css';
import './styles.css';

interface Context extends Props {
  setMarkdown: (markdown: string) => void;
  setVisual: (markdown: string) => void;
}

interface Props {
  visual: UseRemirrorReturn<
    ReactExtensions<ReturnType<typeof visualModeExtensions>[number]>
  >;
  markdown: UseRemirrorReturn<
    ReactExtensions<DocExtension | CodeBlockExtension>
  >;
}

export const [WrapperEditor, useWrapperEditor] = createContextState<
  Context,
  Props
>(({ props }) => ({
  ...props,

  setMarkdown: (text: string) => {
    props.markdown.getContext()?.setContent({
      type: 'doc',
      content: [
        {
          type: 'codeBlock',
          attrs: { language: 'markdown' },
          content: text ? [{ type: 'text', text }] : undefined
        }
      ]
    });
  },
  setVisual: (markdown: string) =>
    props.visual.getContext()?.setContent(markdown)
}));

export const visualModeExtensions = () => [
  new LinkExtension({ autoLink: true }),
  new BoldExtension({}),
  new StrikeExtension(),
  new ItalicExtension(),
  new HeadingExtension({}),
  new BulletListExtension({}),
  new OrderedListExtension(),
  new ListItemExtension({
    priority: ExtensionPriority.High,
    enableCollapsible: true
  }),
  new CodeExtension(),
  new CodeBlockExtension({ supportedLanguages: [jsx, typescript] }),
  new TrailingNodeExtension({}),
  new TableExtension({}),
  new NodeFormattingExtension({}),
  new MarkdownExtension({
    copyAsMarkdown: true
  }),
  new HardBreakExtension(),
  new ImageExtension({ enableResizing: true }),
  new DropCursorExtension({})
];

export const markdownModeExtensions = () => [
  new DocExtension({ content: 'codeBlock' }),
  new CodeBlockExtension({
    supportedLanguages: [md],
    defaultLanguage: 'markdown',
    syntaxTheme: 'base16_ateliersulphurpool_light',
    defaultWrap: true
  })
];
